import { render, staticRenderFns } from "./ShotCard.vue?vue&type=template&id=2fa56643&"
import script from "./ShotCard.vue?vue&type=script&lang=js&"
export * from "./ShotCard.vue?vue&type=script&lang=js&"
import style0 from "./ShotCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports